/*
 * Ürün kartı görsel galerisi — snippets/product-card.liquid.
 *
 * Masaüstünde fare kart görselinin üzerinde sağa sola gezdikçe görsel eşit dikey bölgelere ayrılır ve her bölge
 * ürünün sıradaki görselini gösterir (ilk bölge ana görsel). Fare görselden çıkınca ana görsele döner. Ek görseller
 * kart ilk kez hover edildiğinde yüklenir.
 *
 * Dokunmatik cihazlarda görsel alanı CSS scroll-snap ile parmakla kaydırılır (assets/custom.css); burada yalnızca
 * noktalar kaydırmaya göre güncellenir, ek görseller karta ilk dokunuşta yüklenir ve renk seçilince ana görsele dönülür.
 *
 * Dinleyiciler document'te olduğu için filtreleme, sonsuz kaydırma vb. ile sonradan eklenen kartlarda da çalışır.
 */
(() => {
  if (window.hpProductCardGallery) return;
  window.hpProductCardGallery = true;

  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  let current = null;

  const hoverImages = (figure) => {
    figure.hpHoverImages ??= Array.from(figure.querySelectorAll(':scope > .product-card__media > .product-card__image--hover'));
    return figure.hpHoverImages;
  };

  const loadImages = (figure) => hoverImages(figure).forEach((image) => (image.loading = 'eager'));

  const showDot = (figure, index) => {
    figure.querySelectorAll(':scope > .product-card__hover-dots > span').forEach((dot, i) => dot.classList.toggle('is-active', i === index));
  };

  const show = (figure, index) => {
    if (figure.hpHoverIndex === index) return;
    figure.hpHoverIndex = index;

    hoverImages(figure).forEach((image, i) => image.classList.toggle('is-active', i === index - 1));
    showDot(figure, index);
    figure.classList.toggle('is-hover-scrubbing', index > 0);
  };

  const reset = () => {
    if (current) show(current, 0);
    current = null;
  };

  /* ---------- Masaüstü: fareyle gezme ---------- */

  document.addEventListener('pointermove', (event) => {
    if (event.pointerType !== 'mouse' || !finePointer.matches) return;

    // Hızlı sepete ekle barında bedenler arasında gezerken görsel değişmesin
    if (event.target.closest?.('.hp-quick-add')) return;

    const figure = event.target.closest?.('.product-card__figure');
    const images = figure ? hoverImages(figure) : [];

    if (figure !== current) reset();
    if (images.length === 0) return;

    if (!current) {
      current = figure;
      loadImages(figure);
    }

    const rect = figure.getBoundingClientRect();
    const count = images.length + 1;
    const index = Math.floor(((event.clientX - rect.left) / rect.width) * count);
    show(figure, Math.max(0, Math.min(index, count - 1)));
  }, { passive: true });

  document.addEventListener('pointerout', (event) => {
    if (current && !current.contains(event.relatedTarget)) reset();
  });

  /* ---------- Dokunmatik: parmakla kaydırma ---------- */

  document.addEventListener('touchstart', (event) => {
    const figure = event.target.closest?.('.product-card__figure');
    if (figure && !figure.hpImagesLoaded && hoverImages(figure).length > 0) {
      figure.hpImagesLoaded = true;
      loadImages(figure);
    }
  }, { passive: true });

  // scroll olayı kabarcıklanmaz, capture ile tüm kartların görsel alanları tek dinleyiciyle izlenir
  document.addEventListener('scroll', (event) => {
    const media = event.target;
    if (!media.classList?.contains('product-card__media') || finePointer.matches) return;

    // RTL'de scrollLeft negatif olur
    showDot(media.parentElement, Math.round(Math.abs(media.scrollLeft) / media.clientWidth));
  }, { capture: true, passive: true });

  // Renk seçilince tema ana görseli değiştiriyor; başka bir görseldeyken değişiklik görünsün diye başa dön
  document.addEventListener('change', (event) => {
    if (!event.target.matches?.('.product-card__info [type="radio"]')) return;

    const media = event.target.closest('.product-card')?.querySelector('.product-card__media');
    if (media?.scrollLeft) media.scrollTo({ left: 0, behavior: 'smooth' });
  });
})();
